// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1dJYs","icon":"SortAdornment_icon__3zNi6","up":"SortAdornment_up__2zPkh","down":"SortAdornment_down__3WOZd","active":"SortAdornment_active__sUmuX"};